import { type FC } from 'react';

import { useBalloonHoverHandlers } from './internal/hooks/useBalloonHoverHandlers';
import { usePointHoverHandlers } from './internal/hooks/usePointHoverHandlers';

export const MapPinsHoverHandlers: FC = () => {
  usePointHoverHandlers();

  useBalloonHoverHandlers();

  return null;
};
